/*
 * UpgradeQualification Messages
 *
 * This contains all the text for the UpgradeQualification component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.UpgradeQualification';

export default defineMessages({
  email: {
    id: `${scope}.email`,
    defaultMessage: 'Email',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Send Notification',
  },
});
